/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunPolicyScan {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunPolicyScan.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunPolicyScan>): WellArchitectedFrameworkAssessmentRunPolicyScan {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunPolicyScan(), model);
        WellArchitectedFrameworkAssessmentRunPolicyScan.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunPolicyScan>): WellArchitectedFrameworkAssessmentRunPolicyScan {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunPolicyScan.newInstance(<WellArchitectedFrameworkAssessmentRunPolicyScan> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunPolicyScan) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunPolicyScan.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunPolicyScan): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunPolicyScan.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.evaluated_resource_count === undefined) {
            this.evaluated_resource_count = 0;
        }
        if (this.violated_resource_count === undefined) {
            this.violated_resource_count = 0;
        }
        if (typeof this.started === "string") {
            this.started = new Date(<string><any>this.started);
        }
        if (typeof this.completed === "string") {
            this.completed = new Date(<string><any>this.completed);
        }
        if (this.context) {
            models.WellArchitectedFrameworkAssessmentContext.fixupPrototype(this.context);
        }
    }

    /**
     * Context for the policy execution.
     */
    context: models.WellArchitectedFrameworkAssessmentContext;

    /**
     * ID of the cloud account for this policy Job execution
     */
    cloud_account_id: string;

    /**
     * External Identity of the Policy
     */
    policy_uri: string;

    /**
     * Identity of the Policy Job
     */
    policy_job_id: string;

    /**
     * Status of the policy scan
     */
    status: models.WellArchitectedFrameworkAssessmentRunPolicyScanStatus;

    /**
     * Reason for failure of the policy scan
     */
    failure: string;

    started: Date;

    completed: Date;

    evaluated_resource_count: number;

    violated_resource_count: number;

}
